import type { RequestBody } from '@vrplatform/data';

type CreateAccountRequestBody = RequestBody<'post:/accounts'>;
type BankingInitRequestBody = RequestBody<'post:/accounts/{id}/banking-init'>;

type BankingType = NonNullable<
  NonNullable<CreateAccountRequestBody['banking']>['type']
>;

export type BankingInitAccount = {
  banking?: {
    type?: BankingType | null;
  } | null;
};

export const buildBankingInitRequestBody = (args: {
  account: BankingInitAccount | null | undefined;
  startingBalanceAmount: number;
  startingBalanceDate: BankingInitRequestBody['startingBalanceDate'];
}): BankingInitRequestBody => {
  return {
    startingBalanceAmount:
      args.account?.banking?.type === 'creditCard'
        ? args.startingBalanceAmount * -1
        : args.startingBalanceAmount,
    startingBalanceDate: args.startingBalanceDate,
  };
};
